import type { FC } from 'react'
import { Fragment, useMemo } from 'react'
import { useShallow } from 'zustand/shallow'

import ConfigPreviewDialog from '@/components/molecules/dialogs/ConfigPreviewDialog'
import ExpandedPortsDialog from '@/components/molecules/dialogs/ExpandedPortsDialog'
import PartDetailsDialog from '@/components/molecules/dialogs/PartDetailsDialog'
import PortExpanderDialog from '@/components/molecules/dialogs/PortExpanderDialog'
import SendMyselfDialog from '@/components/molecules/dialogs/SendMyselfDialog'
import WarningDialogType from '@/components/molecules/dialogs/WarningDialog'
import type { Dialog, DialogTypes } from '@/stores/DialogsStore'
import useDialogsStore from '@/stores/DialogsStore'

function Dialogs() {
  const dialogs = useDialogsStore(useShallow(state => state.dialogs))
  const dialogsEntries = useMemo(() =>
    Object.entries(dialogs), [dialogs]) as [DialogTypes, Dialog][]

  const dialogTypeDict: Partial<Record<DialogTypes, FC>> = {
    warning: WarningDialogType,
    sendMyself: SendMyselfDialog,
    partInfo: PartDetailsDialog,
    configurationPreview: ConfigPreviewDialog,
    expandedPorts: ExpandedPortsDialog,
    portExpanderDisabled: PortExpanderDialog,
  }

  return dialogsEntries.map(([key]) => {
    const Slot = dialogTypeDict[key]
    const isOpen = dialogs[key].open

    if (!isOpen) return null

    return (
      <Fragment key={key}>
        {Slot && (
          <Slot />
        )}
      </Fragment>
    )
  })
}

export default Dialogs
